export default {
  name: 'Real Food Campaign',
  domain: 'rfc',
  id: '5e97401756f2b6000176e709',
  slug: 'real-food-campaign',
  path: '/real-food-campaign/',
  logo: '/partners/rfc/img/logo.png',
  themes: {
    light: {
      primary: '#26AAE2',
      secondary: '#26AAE2',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#26AAE2',
      success: '#8bc34a',
      appbar: '#FFFFFF',
    },
  },
};
